














interface ITab {
  id: number
  text: string
}
import { Vue, Prop, Component } from 'vue-property-decorator'
@Component
export default class MTab extends Vue {
  @Prop({ required: true })
  tabs?: Array<ITab>
  @Prop()
  selectedId?: number

  mounted() {}
}
